/* eslint react/forbid-prop-types: 0 */
import React, { createContext, useContext, useReducer } from 'react';

export const StateContext = createContext({});

export const StateProvider = ({ reducer, initialState, children }) => (
  <StateContext.Provider value={useReducer(reducer, initialState)}>
    {children}
  </StateContext.Provider>
);

export const useStateValue = (): any => useContext(StateContext);
